import React from 'react';
import noImg from '../../assets/images/no-img-available.webp';
import membershipLogo from '../../assets/images/membership.jpg';

const ProductImg = ({ item, size, margin, padding }) => {
  const wrapperStyle = {
    backgroundColor: 'white',
    margin,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: size,
    maxHeight: size,
    minWidth: size,
    maxWidth: size
  };

  const imgStyle = {
    padding,
    height: 'auto',
    maxHeight: size,
    width: 'auto',
    maxWidth: size
  };

  function imgSrc() {
    if (item.sku === 'membership') {
      return membershipLogo;
    } else if (item.image_src) {
      return item.image_src;
    } else {
      return '';
    }
  }

  return (
    <div style={wrapperStyle}>
      <img
        style={imgStyle}
        src={imgSrc()}
        alt={item.variant_title || 'No image available'}
        onError={e => (e.target.src = noImg)}
      />
    </div>
  );
};

export default ProductImg;
